<template>
  <!--
    TODO
    Allowed Maximum Amount
    Minumum Amount required
  -->
  <b-sidebar
    id="add-new-coupon-sidebar"
    :visible="isAddNewCouponSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @hidden="resetForm"
    @change="(val) => $emit('update:is-add-new-coupon-sidebar-active', val)"
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          {{ $t('create new coupon') }}
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />

      </div>

      <!-- BODY -->
      <validation-observer
        ref="observer"
        #default="{ invalid }"
      >
        <!-- Form -->
        <b-form
          class="p-2"
          @reset.prevent="resetForm"
          @submit.prevent="onSubmit"
        >

          <!-- Offer Name -->
          <validation-provider
            #default="{ errors }"
            name="offerName"
            rules="required"
          >
            <b-form-group
              :label="$t('offer name')"
              label-for="offer-name"
            >
              <b-form-input
                id="offer-name"
                v-model="form.offerName"
                autofocus
                :state="errors.length > 0 ? false:null"
                trim
                placeholder="20% OFF"
              />

              <b-form-invalid-feedback>
                {{ errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Offer Type -->
          <validation-provider
            #default="{ errors }"
            name="OfferType"
            rules=""
          >
            <b-form-group
              :label="$t('offer type')"
              label-for="offer-type"
            >
              <b-form-radio-group
                v-model="form.offerType"
                :options="options"
                class="demo-inline-spacing"
                name="radio-inline"
                @change="changeAmount(form.offerType)"
              />
              <b-form-invalid-feedback>
                {{ errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Discount Amount -->
          <validation-provider
            #default="{ errors }"
            :name="$t('discount amount percentage')"
            rules="required|integer"
          >
            <b-form-group
              :label="$t('discount amount percentage')"
              label-for="discount-amount"
              :state="errors.length > 0 ? false:null"
            >
              <b-input-group
                :prepend="amountPrepend"
                :append="amountAppend"
              >
                <b-form-input
                  id="discountAmount"
                  v-model.number="form.discountAmount"
                  autofocus
                  :state="errors.length > 0 ? false:null"
                  placeholder="20"
                />
              </b-input-group>

              <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                {{ errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Start Date Time -->
          <validation-provider
            #default="{ errors }"
            name="startDateTime"
            rules=""
          >
            <b-form-group
              :label="$t('start date time')"
              label-for="start-date-time"
            >
              <flat-pickr
                v-model="form.startDateTime"
                class="form-control"
                :config="{ enableTime: true, dateFormat: 'Y-m-d H:i', static: true, time_24hr: true }"
              />

              <b-form-invalid-feedback>
                {{ errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- End Date Time -->
          <validation-provider
            #default="{ errors }"
            name="endDateTime"
            rules=""
          >
            <b-form-group
              :label="$t('end date time')"
              label-for="end-date-time"
            >
              <flat-pickr
                v-model="form.endDateTime"
                class="form-control"
                :config="{ enableTime: true, dateFormat: 'Y-m-d H:i', static: true, time_24hr: true }"
              />

              <b-form-invalid-feedback>
                {{ errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- maximumTotalUsage -->
          <validation-provider
            #default="{ errors }"
            name="maximumTotalUsage"
            rules="between:0,1000"
          >
            <b-form-group
              :label="`${$t('maximum total usage')} (${$t('zero to thousand')})`"
              label-for="company"
            >
              <b-form-input
                id="maximumTotalUsage"
                v-model="form.maximumTotalUsage"
                :state="errors.length > 0 ? false:null"
                placeholder="100"
                trim
              />

              <b-form-invalid-feedback>
                {{ errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- One Per Customer -->
          <validation-provider
            #default="{ errors }"
            name="perCustomer"
            rules=""
          >
            <b-form-group
              :label="`${$t('limit usage')} (${$t('pay function')})`"
              label-for="per-customer"
              :state="errors.length > 0 ? false:null"
            >
              <b-form-checkbox
                v-model="form.perCustomer"
                value="1"
                :disabled="true"
              >
                {{ $t('one time only') }}
              </b-form-checkbox>
              <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                {{ errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Code -->
          <validation-provider
            #default="{ errors }"
            name="coupon code"
            rules="required"
          >
            <b-form-group
              :label="`${$t('customize coupon code')} (${$t('pay function')})`"
              label-for="coupon-code"
            >
              <b-form-input
                id="coupon-code"
                v-model="form.code"
                autofocus
                :state="errors.length > 0 ? false:null"
                trim
                :disabled="true"
              />

              <b-form-invalid-feedback>
                {{ errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Description -->
          <validation-provider
            #default="{ errors }"
            name="description"
            rules="max:50"
          >
            <b-form-group
              :label="$t('description')"
              label-for="description"
              :state="errors.length > 0 ? false:null"
            >
              <b-form-textarea
                id="description"
                v-model="form.description"
                placeholder="則扣限制200元低消"
                rows="3"
              />
              <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                {{ errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Form Actions -->
          <div class="d-flex mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              type="submit"
              :disabled="invalid"
            >
              {{ $t('create') }}
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-secondary"
              @click="hide"
            >
              {{ $t('cancel') }}
            </b-button>
          </div>

        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BFormInput, BFormInvalidFeedback, BButton, BFormRadioGroup, BFormTextarea, BFormCheckbox, BInputGroup,
} from 'bootstrap-vue'
import { mapGetters } from 'vuex'
import { extend, ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, alphaNum, email } from '@validations'
import * as rules from 'vee-validate/dist/rules'
import flatPickr from 'vue-flatpickr-component'
import Ripple from 'vue-ripple-directive'
import VoucerCodeGenerator from 'voucher-code-generator'
import store from '@/store'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule])
})

export default {
  components: {
    BSidebar,
    BFormRadioGroup,
    BForm,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BFormInvalidFeedback,
    BButton,
    BFormTextarea,
    BFormCheckbox,
    flatPickr,

    // Form Validation
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  model: {
    prop: 'isAddNewCouponSidebarActive',
    event: 'update:is-add-new-coupon-sidebar-active',
  },
  props: {
    isAddNewCouponSidebarActive: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      form: {
        startDateTime: null,
        endDateTime: null,
        offerName: '',
        offerType: 'percentage',
        maximumTotalUsage: 0,
        perCustomer: 0,
        discountAmount: null,
        codes: [],
        campaigns: ['*'],
        description: '',
      },
      amountPrepend: '',
      amountAppend: '%',
      required,
      alphaNum,
      email,
      options: [
        { text: this.$t('percentage'), value: 'percentage' },
        { text: this.$t('flat'), value: 'flat' },
      ],
    }
  },
  computed: {
    ...mapGetters(['user']),
  },
  async mounted() {
    this.form.code = this.getCode()
  },
  methods: {
    resetForm() {
      this.form = {
        startDateTime: null,
        endDateTime: null,
        offerName: '',
        offerType: 'percentage',
        maximumTotalUsage: 0,
        perCustomer: 0,
        discountAmount: null,
        codes: [],
        code: this.getCode(),
        campaigns: ['*'],
        description: '',
      }
      this.$refs.observer.reset()
      this.discountAmountText = 'discount amount'
    },
    getCode: () => {
      const [code] = VoucerCodeGenerator.generate({
        length: 8,
        count: 1,
        charset: VoucerCodeGenerator.charset('alphabetic'),
      })
      return code
    },
    changeAmount(selected) {
      if (selected === 'flat') {
        this.amountPrepend = '$'
        this.amountAppend = '.00'
      } else if (selected === 'percentage') {
        this.amountPrepend = ''
        this.amountAppend = '%'
      }
    },
    onSubmit() {
      store.dispatch('createCoupon', { ...this.form, uid: this.user.uid }).then(() => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Coupon Created',
            icon: 'AwardIcon',
            variant: 'success',
          },
        })
        this.$emit('refetch-data')
        this.$emit('update:is-add-new-coupon-sidebar-active', false)
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
